import {Router} from "@angular/router";
import {ComponentRef, ViewContainerRef} from "@angular/core";
import {Observable, timer} from "rxjs";
import scrollIntoView from "scroll-into-view-if-needed";

import {MixinConstructor} from "./mixin.define";
import {LINK_POPUP_DELAY, LIST_TYPE, RESULT_LINKPOPUP, SearchParam} from "../defines/client.const";
import {DynamicComponentService} from "../services/dynamic-component/dynamic-component.service";
import {HanjaWordPopupComponent} from "../components/hanja-word-popup/hanja-word-popup.component";


type HanjaWordMixinType = {
  router: Router,
  dynamicSvc: DynamicComponentService,
};

/**
 * 단일 mixin을 사용하는 경우의 정의.
 */
export const HanjaWordMixin = HanjaWordMixinFunction(
  class Parent {
    constructor(
      public router: Router,
      public dynamicSvc: DynamicComponentService,
    ) {
    }
  }
);

export function HanjaWordMixinFunction<BaseType extends MixinConstructor<HanjaWordMixinType>>(BaseClass: BaseType) {
  return class extends BaseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    private elRefHanjaWordPopup: ComponentRef<HanjaWordPopupComponent> | null = null;


    /**
     * 한자 단어 팝업창을 연다.
     * @param hanja - 팝업창에 표시할 한자
     * @param container - 링크 팝업창을 열 기준이 되는 요소
     * @param hangul - 음 (1글자, 예: "국")
     * @param firstHun - 대표 훈 (예: "나라")
     */
    public OpenHanjaWord(hanja: string, container: ViewContainerRef, hangul?: string, firstHun?: string): Observable<RESULT_LINKPOPUP> {
      console.log('HanjaWordMixin::OpenHanjaWord() : hanja=', hanja, 'hangul=', hangul, 'firstHun=', firstHun);

      return new Observable<RESULT_LINKPOPUP>(observer => {
        try {
          this.elRefHanjaWordPopup = this.dynamicSvc.createComponent(HanjaWordPopupComponent, container);

          /******************************************************************************************
           * 팝업창이 닫힐 때 발생하는 이벤트 처리.
           */
          this.elRefHanjaWordPopup.instance.close.subscribe((hanja: string | null) => {
            console.log('HanjaWordMixin::OpenHanjaWord() : hanja=', hanja);

            observer.next(RESULT_LINKPOPUP.POPUP_CLOSE);

            if (hanja) {
              const queryParams: SearchParam = {
                hanja,
              };
              // 음(hangul)은 한자가 있을 때만 함께 전달하는 선택 파라미터다.
              if (hangul) {
                queryParams.hangul = hangul;
              }
              this.router.navigate(['/word', LIST_TYPE.SERVER], {queryParams}).then();

              observer.next(RESULT_LINKPOPUP.GOTO_LINK);
            }

            observer.complete();
            this.closeHanjaWordPopup();
          });

          /******************************************************************************************
           * 화면에 초기화 된 후 (ngAfterViewInit()) 발생하는 이벤트 처리.
           */
          this.elRefHanjaWordPopup.instance.viewInit.subscribe((nativeEl: HTMLElement) => {

            // 팝업창이 열리는 애니메이션이 끝난 뒤에 스크롤 해야 정확한 위치로 스크롤이 된다.
            timer(LINK_POPUP_DELAY).subscribe(() => {
              console.log('HanjaWordMixin::OpenHanjaWord() : viewInit=', nativeEl);

              scrollIntoView(nativeEl, {
                behavior: 'smooth',
                block: 'end',
                scrollMode: 'if-needed',
              });
            });
          });

          /******************************************************************************************
           * 팝업창에 표시할 정보 설정.
           */
          this.elRefHanjaWordPopup.instance.hanja = hanja;
          this.elRefHanjaWordPopup.instance.hangul = hangul;
          this.elRefHanjaWordPopup.instance.firstHun = firstHun;
          this.elRefHanjaWordPopup.changeDetectorRef.detectChanges();
        } catch (err) {
          console.error('HanjaWordMixin::OpenHanjaWord() : Failed to create popup', err);
          observer.error(err);
        }
      });
    }

    private closeHanjaWordPopup(): void {
      if (this.elRefHanjaWordPopup) {
        this.elRefHanjaWordPopup.destroy();
        this.elRefHanjaWordPopup = null;
      }
    }
  };
}
